import { Field } from "formik";
import React, { useState } from "react";
import { FieldButtonGroup, FieldInput, FieldInputPassword } from "../Forms";
import UploadSSHComponent from "../UploadSSHComponent";

const FTPDetails = (props) => {
  const { showFtpDetails, required, fields, values, setValue, fileUploadRequired, setFileUploadRequired, mapType } = props;
  const AuthenticationMethod = [
    {
      label : "Password",
      value : 0
    },
    {
      label : "SSH",
      value : 1
    },
  ]
  const AuthenticaitonEnum = {
    Password: 0,
    SSH: 1,
  };  
  
  return (
    <>
      {showFtpDetails && (
        <div style={{ width: "20rem", paddingTop: "0.5rem" }}>
          <Field
            name={fields.ftpUrl}
            placeholder={"eg : ftp://yourname@host.dom/"}
            label={"FTP URL"}
            noLabelTransform
            value={values[fields.ftpUrl]}
            component={FieldInput}
            isRequired
            validate={showFtpDetails && required}
          />
          <Field
            name={fields.ftpPath}
            placeholder={"eg : ftp.yourname@host.dom/batchfile"}
            label={"FTP path"}
            noLabelTransform
            value={values[fields.ftpPath]}
            component={FieldInput}
            isRequired
            validate={showFtpDetails && required}
          />
          <Field
            name={fields.username}
            placeholder={"Enter UserName"}
            label={"UserName"}
            noLabelTransform
            value={values[fields.username]}
            component={FieldInput}
            isRequired
            validate={showFtpDetails && required}
          />
          {(mapType != 2 ) &&
              <Field
              name={fields.password}
              placeholder={"Enter Password"}
              label={"Password"}
              noLabelTransform
              value={values[fields.password]}
              component={FieldInputPassword}
              isRequired
              validate={showFtpDetails && required}
            /> 
          }
          {(mapType == 2) &&
            <>
              <Field
              isRequired
              name={fields.authentication}
              noLabelTransform
              label={"Authentication Method"}
              size="sm"
              options={AuthenticationMethod}
              value = {values[fields.authentication]}
              component={FieldButtonGroup}
              validate = {showFtpDetails && required}
              onChange={(value) => {
                setValue(fields.authentication, value);
              }}
              selectedValue={values[fields.authentication]}
              // defaultValue = {}
            />
          {(showFtpDetails && values[fields.authentication]) == AuthenticaitonEnum.Password &&
            <Field
              name={fields.password}
              placeholder={"Enter Password"}
              label={"Password"}
              noLabelTransform
              value={values[fields.password]}
              component={FieldInputPassword}
              isRequired
              validate={showFtpDetails && required}
            /> 
          }
          {
            (showFtpDetails &&  values[fields.authentication]) == AuthenticaitonEnum.SSH &&
            <div>
              <UploadSSHComponent
                  name={fields.sshKey}
                  values={values}
                  setFieldValue={setValue}
                  label="Upload Private Key file"
                  fileExtensions='.pem, .key'
                  setFileUploadRequired = {setFileUploadRequired}
                  // fieldName = {fields.sshKey}
                />
                <div
                  style={{
                    fontSize: "0.75rem",
                    marginTop: "0rem",
                    color: "#ff5050",
                  }}
                >
                <span
                  style={{ fontSize: "10px", color: "red" }}
                >
                  {fileUploadRequired}
                </span>
              </div>
            </div>
          }
          </>
          }
        </div>
      )}
    </>
  );
};

export default FTPDetails;
